import { Box, Button, TextField } from '@mui/material'
import { useTranslation } from 'react-i18next';

interface Props {
    itemCodeRef: React.RefObject<HTMLInputElement>;
    titleTextField: string;
    onSearchProduct: () => void;
}

const SearchProductField = ({ itemCodeRef, titleTextField, onSearchProduct }: Props) => {
      const { t } = useTranslation('global');
    return (

        <Box sx={{ display: 'flex', alignItems: 'center' }}>
            <TextField fullWidth margin="normal" size='small' label={titleTextField} inputRef={itemCodeRef} InputLabelProps={{ shrink: true }} sx={{
                '& .MuiOutlinedInput-root': {
                    borderTopRightRadius: 0,
                    borderBottomRightRadius: 0,
                    borderRadius: '8px 0 0 8px',
                    // height: 55,
                },
            }} />
            <Button variant='contained' color='secondary' sx={{
                textTransform: 'none',
                height: 39,
                borderTopLeftRadius: 0,
                borderBottomLeftRadius: 0,
                borderRadius: '0 8px 8px 0',
                marginTop: 1,
                color: '#fff'
            }} onClick={() => onSearchProduct()}>{t("promotion_page.Search")}</Button>
        </Box>
    )
}

export default SearchProductField